import { render, staticRenderFns } from "./OpportunityScoreRenderer.vue?vue&type=template&id=497e654f&scoped=true&"
import script from "./OpportunityScoreRenderer.vue?vue&type=script&lang=js&"
export * from "./OpportunityScoreRenderer.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityScoreRenderer.vue?vue&type=style&index=0&id=497e654f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e654f",
  null
  
)

/* custom blocks */
import block0 from "./OpportunityScoreRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports